module.exports = __webpack_public_path__ + "img/img17.379bf42c.svg";